export enum AccountsSort {
    CODE_ASC = 'code',
    NAME_ASC = 'name',
    BUSINESS_NAME_ASC = 'businessName',
    CODE_DESC = '-code',
    NAME_DESC = '-name',
    BUSINESS_NAME = '-businessName',
}
